import { render, staticRenderFns } from "./misApfResidencyInputs.vue?vue&type=template&id=5848077d&scoped=true"
import script from "./misApfResidencyInputs.vue?vue&type=script&lang=js"
export * from "./misApfResidencyInputs.vue?vue&type=script&lang=js"
import style0 from "./misApfResidencyInputs.vue?vue&type=style&index=0&id=5848077d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848077d",
  null
  
)

export default component.exports